import { execute, addQueryParams } from '@/api/utils'
import { GET, POST, PUT, DELETE } from '@/api/types'

export default {
  list (farmID, params = {}) {
    return execute(GET, addQueryParams(`farms/${farmID}/housing`, params))
  },
  create (farmID, payload) {
    return execute(POST, `farms/${farmID}/housing`, payload)
  },
  getById (farmID, id) {
    return execute(GET, `farms/${farmID}/housing/${id}`)
  },
  updateById (farmID, id, payload) {
    return execute(PUT, `farms/${farmID}/housing/${id}`, payload)
  },
  deleteById (farmID, id) {
    return execute(DELETE, `farms/${farmID}/housing/${id}`)
  }
}
